import { useMediaQuery } from 'react-responsive';

export interface ScreenInfo {
    screenSize: 'large' | 'medium' | 'small' | 'extrasmall'
}

export const useScreenType = () : ScreenInfo | undefined => {
    const isLarge: boolean = useMediaQuery({ minWidth: 1440 });
    const isMedium: boolean = useMediaQuery({ minWidth: 1265 })
    const isSmall: boolean = useMediaQuery({ minWidth: 800 });

    if(isLarge)
        return { screenSize: 'large' };

    if(isMedium)
        return { screenSize: 'medium' };

    if(isSmall)
        return { screenSize: 'small' };

    return { screenSize: 'extrasmall' };
};